import React, { useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { graphColorCodes } from '../utils';
import { Card, Avatar, InlineStack, Text, BlockStack } from '@shopify/polaris';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

export default function PerformanceGraph({ p, noAxes = false, noYAxis = false, timeSeriesData, height = '400px', labels, title, subtitle, dateStrings, timeSeriesRaw, label }) {

  const t = title?.includes('Revenue') ? 'Revenue' : title?.includes('Cost') ? 'Cost' : title?.includes('Posts') ? 'Posts' : title?.includes('Engagements') ? 'Engagements' : 'Clicks';
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    stacked: false,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: false,
        text: title,
      },
      tooltip: {
        callbacks: {
          label: function(item) {
            return `${item.dataset?.label}: ${(t === 'Revenue' || t === 'Cost') ? '$' : ''}${item.formattedValue}`
          }
        }
      },
    },
    scales: {
      y: {
        type: 'linear',
        display: (noAxes || noYAxis) ? false : true,
        position: 'left',
        grid: {
          display: timeSeriesRaw ? false : true,
        },
        ticks: {
          autoSkip: true,
          maxTicksLimit: timeSeriesRaw ? 5 : 10,
          min: 1,
          // Include a dollar sign in the ticks
          callback: function(value, index, ticks) {
            if (title !== 'Revenue' && title !== 'Cost') {
              if (Math.floor(value) === value) {
                return value;
              }
            } else {
              return '$' + value;
            }
          },
        },
        min: 0,
      },
      x: {
        display: noAxes ? false : true,
        ticks: {
          autoSkip: true,
          maxTicksLimit: timeSeriesRaw ? 5 : 30,
        },
        grid: {
          display: false
        }
      },
      /*
      y1: {
        type: 'linear',
        display: true,
        position: 'right',
        grid: {
          drawOnChartArea: false,
        },
      },
    */
    },
  };

  console.log('timeSeriesData', timeSeriesData)
  let datasets;
  if (timeSeriesRaw) {
    datasets = [{
      label,
      data: timeSeriesRaw,
      fill: true,
      borderColor: graphColorCodes[(title?.includes('Revenue') || label === 'Revenue') ? 0 : (label === 'Clicks') ? 3 : (label === 'Leads' || label?.includes('Activated')) ? 8 : label === 'Cost' ? 9 : 2],
      backgroundColor: graphColorCodes[(title?.includes('Revenue') || label === 'Revenue') ? 0 : (label === 'Clicks') ? 3 : (label === 'Leads' || label?.includes('Activated')) ? 8 : label === 'Cost' ? 9 : 2].replace(', 1)', ', 0.2)'),
      tension: 0.4,
      yAxisID: 'y',
      pointRadius: 0,
    }]
  } else {
    datasets = Object.values(timeSeriesData || {})
      .filter(data => t === 'Revenue' ? data.revenueTotal : t === 'Cost' ? data.costTotal : t === 'Posts' ? data.postsTotal : t === 'Engagements' ? data.engagementsTotal : data.clicksTotal)
      .map((data, index) => {
        console.log('data', data)
        return {
          label: data?.creator?.creator?.name || data?.campaignTitle,
          data: t === 'Revenue' ? data?.revenueTimeSeries : t === 'Cost' ? data?.costTimeSeries : t === 'Posts' ? data?.postsTimeSeries : t === 'Engagements' ? data.engagementsTimeSeries : data?.clicksTimeSeries,
          fill: true,
          borderColor: graphColorCodes[index % graphColorCodes.length],
          backgroundColor: graphColorCodes[index % graphColorCodes.length].replace(', 1)', ', 0.2)'),
          creator: data?.creator?.creator,
          campaignTitle: data?.campaignTitle,
          tension: 0.4,
          yAxisID: 'y',
          pointRadius: 0,
        }
      })
  }

  const data = {
    labels,
    datasets,
  };
  return (
    <Card padding={p}>
      <BlockStack gap="300">
        <BlockStack inlineAlign="center">
          <Text color="subdued" variant={timeSeriesRaw ? "headingMd" : "headingLg"}>{title}</Text>
          <InlineStack gap="100">
            {
              subtitle ? (
                <>{subtitle}<Text>-</Text></>
              ) : null
            }
            <Text>{dateStrings}</Text>
          </InlineStack>
        </BlockStack>
        <div style={{ height }}>
          <Line options={options} data={data} />
        </div>
      </BlockStack>
      <InlineStack gap="300" align="center">
        {!timeSeriesRaw ? datasets.map((data, index) => (
          <InlineStack key={index} gap="100" blockAlign="center">
            <div style={{ padding: "2px", borderRadius: '3px', backgroundColor: data.backgroundColor, border: `3px solid ${data.borderColor}` }}>
              <InlineStack gap="100">
                {
                  data?.creator ? (
                    <Avatar size="extraSmall" shape="square" source={data.creator?.profile?.profile?.picture} initials={data.creator?.name?.[0]} />
                  ) : null
                }
                <Text>{data?.creator?.name || data?.campaignTitle}</Text>
              </InlineStack>
            </div>
          </InlineStack>
        )) : null}
      </InlineStack>
    </Card>
  )
}

